import React from 'lib/react';

import {
  EVGrid, EVPaper, EVTypography, EVButton,
} from 'lib/components';

import { useTranslation } from 'lib/translation';
import history from 'store/CreateHistory';
import { DASHBOARD_ROUTE } from 'constants/RouteConstants';
import BillingAffiliateViewStyles from './BillingAffiliateViewStyles';

export default function BillingAffiliateView() {
  const { t } = useTranslation();
  const classes = BillingAffiliateViewStyles();

  const handleClick = () => history.push(DASHBOARD_ROUTE);

  return (
    <EVPaper className={classes.paper}>
      <EVGrid className={classes.container} container direction="column">
        <EVTypography className={classes.title}>{t('billing_affiliate__title')}</EVTypography>
        <EVButton
          id="redirectToDashboard"
          variant="contained"
          style={{ backgroundColor: '#007CAD', color: '#FFFFFF' }}
          className={classes.button}
          onClick={handleClick}
        >
          {t('billing_affiliate__dashboard')}
        </EVButton>
      </EVGrid>
    </EVPaper>
  );
}
